import adminApi from "./adminApi";


// fetch all categories
export const fetchCategories = async () => {
  const res = await adminApi.get("/category/list");
  return res.data;
};

export const fetchProducts = async () => {
  const res = await adminApi.get("/admin/products");
  return res.data;
};
export const fetchProductById = async (id) => {
  const res = await adminApi.get(`/admin/products/${id}`);
  return res.data;
};


export const createProduct = async (data) => {
  const res = await adminApi.post("/admin/products", data);
  return res.data;
};

export const updateProduct = async (id, data) => {
  console.log("update",data);
  const res = await adminApi.put(`/admin/products/${id}`, data);
  return res.data;
};


export const deleteProduct = async (id) => {
  return adminApi.delete(`/admin/products/${id}`);
};
